import { SuretyAccountId } from "@inrev/common";
import { useFlags } from "@portal/providers/GlobalFlagsProvider";
import { useQuery } from "@tanstack/react-query";
import { downloadFileFromDataBlob } from "../../../utils/download";
import { useRequest } from "../../../utils/request";
import { accountIndemnityAgreementDownloadQueryKey } from "../account.keys";

export const useAdminDownloadIndemnityAgreement = (accountId: SuretyAccountId) => {
	const { get } = useRequest();
	const { showErrorFlag } = useFlags();

	const url = `/v2/admin/surety/accounts/${accountId}/indemnity-agreements/file`;
	const { refetch, data, error, isLoading } = useQuery({
		queryKey: accountIndemnityAgreementDownloadQueryKey(accountId),
		queryFn: async () => await get(url, undefined, "blob"),
		staleTime: 60000,
		enabled: false,
	});

	const downloadIndemnityAgreement = () => {
		refetch().then(({ data, isError }) => {
			if (data) {
				downloadFileFromDataBlob(data, "indemnity-agreement.pdf");
			} else if (isError) {
				showErrorFlag({ message: "Failed to download indemnity agreement" });
			}
		});
	};

	return {
		downloadIndemnityAgreement: downloadIndemnityAgreement,
		indemnityAgreement: data,
		indemnityAgreementError: error,
		indemnityAgreementLoading: isLoading,
	};
};
